import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../config";
import TRUCK_TYPES from "../assets/truck_types.js";

const Carriers = () => {
  const [savedCarriers, setSavedCarriers] = useState([]);
  const [, setAvailableCarriers] = useState([]);
  const [, setLoading] = useState(true);
  const [, setError] = useState(null);

  const getTruckTypeName = (code) => {
    const truckType = TRUCK_TYPES.find((type) => type.value === code);
    return truckType ? truckType.label : code;
  };

  useEffect(() => {
    fetchCarriers();
  }, []);

  const fetchCarriers = async () => {
    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem("access_token");

      // Fetch both saved and available carriers in parallel
      const [savedResponse, availableResponse] = await Promise.all([
        axios.get(`${API_URL}/user/carriers`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
        axios.get(`${API_URL}/user/carriers/available`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
      ]);

      setSavedCarriers(savedResponse.data);
      setAvailableCarriers(availableResponse.data);
    } catch (err) {
      console.error("Error fetching carriers:", err);
      setError("Failed to load carriers. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const CarrierGrid = ({ carriers, emptyMessage }) => (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
        gap: "20px",
        padding: "20px",
      }}
    >
      {carriers.map((carrier) => (
        <div
          key={carrier.email}
          style={{
            backgroundColor: "var(--surface)",
            borderRadius: "10px",
            padding: "20px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            transition: "transform 0.2s ease",
            cursor: "pointer",
            position: "relative",
            ":hover": {
              transform: "translateY(-2px)",
            },
          }}
        >
          <h3
            style={{
              fontSize: "1.2rem",
              marginBottom: "10px",
              color: "var(--primary)",
              paddingRight: "60px",
            }}
          >
            {carrier.name}
          </h3>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              fontSize: "0.9rem",
              color: "#8b949e",
            }}
          >
            {carrier.company_name && (
              <div>
                <strong>Company:</strong> {carrier.company_name}
              </div>
            )}
            <div>
              <strong>Email:</strong> {carrier.email}
            </div>
            {carrier.phone_number && (
              <div>
                <strong>Phone:</strong> {carrier.phone_number}
              </div>
            )}
            {carrier.truck_type && (
              <div>
                <strong>Truck Type:</strong>{" "}
                {getTruckTypeName(carrier.truck_type)}
              </div>
            )}
            {carrier.origin_city && (
              <div>
                <strong>Origin City:</strong> {carrier.origin_city}
              </div>
            )}
          </div>
        </div>
      ))}

      {carriers.length === 0 && (
        <div
          style={{
            gridColumn: "1 / -1",
            textAlign: "center",
            padding: "40px",
            color: "#8b949e",
            backgroundColor: "var(--surface)",
            borderRadius: "10px",
          }}
        >
          {emptyMessage}
        </div>
      )}
    </div>
  );

  return (
    <div
      style={{
        padding: "40px 20px",
        maxWidth: "1200px",
        margin: "0 auto",
        color: "var(--text)",
      }}
    >
      <h1
        style={{
          fontSize: "2rem",
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        My Carriers
      </h1>

      <div
        style={{
          textAlign: "center",
          marginBottom: "30px",
          color: "#8b949e",
          fontSize: "1.1rem",
        }}
      >
        These are carriers who have added you to their dispatchers list
      </div>

      <CarrierGrid
        carriers={savedCarriers}
        emptyMessage="No carriers have added you to their dispatchers list yet."
      />
    </div>
  );
};

export default Carriers;
